// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__r1VqF","buttons":"SendReceipts_buttons__3m4T9","email":"SendReceipts_email__2rgEF","bookApptTitle":"SendReceipts_bookApptTitle__19Fw3"};